import { Grid, Typography } from '@material-ui/core';
import React from 'react'
import {isUndefined} from 'underscore'
import {
    Container, Wrapper, Title, Text, GridContainer, ImageWrapper, Image, DescContainer, DescName, Description
} from './PresentersElements'


function Presenters(props) {
    const {presenters} = props;

    return(
        <Container>
            <Wrapper>
            <Grid container direction="column"  
            id="presenters"
            alignItems="center" style={{marginBottom:"50px"}}>
                    <Typography variant="h4" style={{marginTop:"20px",color:"#0E1B4D",fontWeight:"bold",marginTop:"50px"}}>
                        IZLAGAČI
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                        Pregled izlagača
                    </Typography>
                </Grid>
                <GridContainer>
                    {isUndefined(presenters) ?
                        null
                        :
                        Object.keys(presenters).map((el) => (
                            <ImageWrapper>
                                <Image className="slika">
                                    <img src={presenters[el].slika} alt={presenters[el].ime + " " + presenters[el].prezime}/>
                                </Image>
                                <DescContainer className="animacija">
                                    <DescName>
                                        {presenters[el].ime + " " + presenters[el].prezime}
                                    </DescName>
                                    <Description>
                                        {presenters[el].opis}
                                    </Description>
                                </DescContainer>
                            </ImageWrapper>
                                
                        ))    
                
                }
                </GridContainer>
            </Wrapper>
        </Container>
    )
}

export default Presenters